import { useContext } from "react";
import { T } from "../../hooks/useTranslate";
import { Box, Menu, FormControl, RadioGroup } from "@mui/material"
import { PartnersContext } from "../../hooks/PartnersContext";
import { FilterRadioButton } from "../../components/filters/FilterRadioButton";
import { styles } from "./partners.styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const PartnersSortButtonMenu = ({ anchorEl, handleClose, open, logEvent }) => {
  const { sortModel, setSortModel, setMobileColumn } = useContext(PartnersContext);

  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));

  const handleSortChange = (e) => {
    logEvent("partners_sort_change", {
      location: 'partners',
      sort_by: e.target.value
    })
    setSortModel([{
      field: e.target.value, sort: sortModel[0].sort
    }])
    
    if (e.target.value !== "name") {
      setMobileColumn(e.target.value);
    }

    handleClose();
  }

  const handleOrderChange = (e) => {
    setSortModel([{
      field: sortModel[0].field, sort: e.target.value
    }])
    handleClose();
  }

  return (
    <Menu
      id="sort-partners-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "sort-partners-menu-button",
        style: {
          paddingBottom: "0px",
        }
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          style: {
            ...styles.paperPropsStyle,
            width: !viewportIsSmall && "100%"
          }
        }
      }}
    >
      <Box sx={styles.menuContainer}>
        <Box sx={styles.subheaderStyle}><T isUpperCase={true}>sort</T></Box>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            id="radioGroupSortMenu"
            value={sortModel[0].field}
            onChange={handleSortChange}
          >
            <FilterRadioButton
              id="name"
              value="name"
              text="name"
              type="sortOption"
            />
            <FilterRadioButton
              id="nextRank"
              value="nextRank"
              text="ov_to_next_rank"
              type="sortOption"
            />
            <FilterRadioButton
              id="newPartners"
              value="newPartners"
              text="new_partners"
              type="sortOption"
            />
            <FilterRadioButton
              id="centurionCount"
              value="centurionCount"
              text="centurion"
              type="sortOption"
            />
            <FilterRadioButton
              id="cpv"
              value="cpv"
              text="pv"
              type="sortOption"
            />
            <FilterRadioButton
              id="tv"
              value="uncompressedTv"
              text="tv"
              type="sortOption"
            />
            <FilterRadioButton
              id="totalOv"
              value="totalOv"
              text="total_ov"
              type="sortOption"
            />
            <FilterRadioButton
              id="relevance"
              value="relevance"
              text="relevance"
              type="sortOption"
            />
          </RadioGroup>
        </FormControl>
        <Box mt={1}>
          <Box sx={styles.subheaderStyle}><T isUpperCase={true}>order</T></Box>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              id="radioGroupPurchasePeriodDateRange"
              value={sortModel[0].sort}
              onChange={handleOrderChange}
            >
              <FilterRadioButton
                id="asc"
                value="asc"
                text="ascending"
                type="orderOption"
              />
              <FilterRadioButton
                id="desc"
                value="desc"
                text="descending"
                type="orderOption"
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>

    </Menu>
  )
}

export { PartnersSortButtonMenu }
